export enum FeatureFlag {
  AccountAccessDocuments = "account_access_documents",
  EquivoltKpiDashboards = "equivolt_kpi_dashboards",
  EquivoltShopCatalogueProducts = "equivolt_shop_catalogue_products",
  EquivoltTcoCalculator = "equivolt_tco_calculator",
  GasShopAccessDocuments = "gas_shop_access_documents",
  GasShopGasMixtureDetails = "gas_shop_gas_mixture_details",
  WidAccessSettings = "wid_access_settings",
}
